import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Container,
  Row,
  Col,
} from "reactstrap";
import PageLayout from "./PageLayout";
import { useForm, Controller } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { contactApi } from "src/network/api";

function ContactPage() {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onChange",
  });

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await contactApi(data);
      if (response.status === 200 || response.data.status === 200) {
        toast.success("Message sent successfully!");
        reset({ name: "", email: "", message: "" }); // Reset the form fields to their
      } else {
        toast.error("Something went wrong. Please try again."); // Error message
      }
    } catch (error) {
      toast.error("Failed to send message. Please try later.");
    } finally {
      setLoading(false); // Stop the loading indicator
    }
  };

  return (
    <PageLayout>
      <main>
        <section
          className="section section-shaped section-lg"
          style={{
            backgroundColor: "#f8f9fa",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container fluid>
            <Row className="justify-content-center">
              {/* Left Side: Contact Info */}
              <Col lg="4" className="mb-4 mb-lg-0">
                <Card
                  className="shadow border-0"
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "white",
                    padding: "20px",
                  }}
                >
                  <h5>Contact us on</h5>
                  <p className="d-flex align-items-center">
                    <i className="fa fa-whatsapp text-green" />{" "}
                    <a className="ml-2" href="tel:918809483399">
                      +91-8809483399
                    </a>
                  </p>
                  <p className="d-flex align-items-center">
                    <i className="ni ni-email-83 text-primary" />{" "}
                    <a className="ml-2" href="mailto:support@ifrjindex.com">
                      support@ifrjindex.com
                    </a>
                  </p>
                  <hr />
                  <p>
                    <strong>IFRJ Index</strong>
                    <br />
                    <small>
                      A comprehensive, integrated platform bringing together
                      Faculty members, Researchers, Research publications,
                      Publishers and Journals worldwide.
                    </small>
                  </p>
                </Card>
              </Col>

              {/* Right Side: Form */}
              <Col lg="6">
                <Card
                  className="shadow border-0"
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "white",
                  }}
                >
                  <CardHeader
                    className="text-white text-center"
                    style={{
                      backgroundColor: "#5e72e4",
                      borderRadius: "15px 15px 0 0",
                      padding: "1.5rem",
                    }}
                  >
                    <h4 style={{ fontWeight: "600", margin: 0 }}>Contact Us</h4>
                    <p style={{ fontSize: "0.9rem", margin: "0.5rem 0 0" }}>
                      We'd love to hear from you!
                    </p>
                  </CardHeader>
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form" onSubmit={handleSubmit(onSubmit)}>
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              borderColor: "transparent",
                            }}
                          >
                            <i className="ni ni-circle-08 text-primary" />
                          </InputGroupText>
                          <Controller
                            name="name"
                            control={control}
                            rules={{
                              required: "Name is required",
                              minLength: {
                                value: 3,
                                message: "Name must be at least 3 characters",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Your Name"
                                type="text"
                              />
                            )}
                          />
                        </InputGroup>
                        {errors.name && (
                          <div
                            className="error-text"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {String(errors.name?.message)}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              borderColor: "transparent",
                            }}
                          >
                            <i className="ni ni-email-83 text-primary" />
                          </InputGroupText>
                          <Controller
                            name="email"
                            control={control}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value:
                                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                message: "Invalid email address",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Your Email"
                                type="email"
                              />
                            )}
                          />
                        </InputGroup>
                        {errors.email && (
                          <div
                            className="error-text"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {String(errors.email?.message)}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Controller
                          name="message"
                          control={control}
                          rules={{
                            required: "Message is required",
                            minLength: {
                              value: 10,
                              message: "Message must be at least 10 characters",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              className="form-control-alternative"
                              placeholder="Your Message"
                              rows="4"
                              type="textarea"
                            />
                          )}
                        />
                        {errors.message && (
                          <div
                            className="error-text"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {String(errors.message?.message)}
                          </div>
                        )}
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="btn-lg"
                          color="primary"
                          type="submit"
                          style={{
                            backgroundColor: "#5e72e4",
                            borderColor: "transparent",
                            borderRadius: "50px",
                            padding: "0.8rem 2rem",
                          }}
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Send Message"}
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <footer
          className="bg-dark text-white text-center py-3"
          style={{ marginTop: "2rem" }}
        ></footer>
      </main>
    </PageLayout>
  );
}

export default ContactPage;
